import React, {Fragment} from 'react'
import {Nullable} from '../../../../Common/TypeHelper'
import {GENDER} from '../../../../Common/Constants'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {ConfirmContent} from '../../Molecules/BaseContentBlocks/ConfirmContent'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../Atoms/Dividers'
import {MemberNameConfirms, MemberNameConfirmsProps} from './MemberNameConfirms'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {useTranslation} from 'react-i18next'

type BasicMemberInfoConfirmContentsProps = MemberNameConfirmsProps & {
  topMessage?: string[]
  mail: string
  gender: Nullable<string>
  birthday: Nullable<string>
}

export const BasicMemberInfoConfirmContents: React.VFC<BasicMemberInfoConfirmContentsProps> = (
  {
    topMessage,
    mail,
    familyName,
    firstName,
    familyNameKana,
    firstNameKana,
    gender,
    birthday,
  },
): JSX.Element => {
  const {t} = useTranslation('member')

  const displayTopMessage = (): Nullable<JSX.Element> => {
    if (topMessage?.length === 0) {
      return null
    }

    return <ContentTopMessage data-testid={'basic-info-top-message'}>
      {topMessage?.map((message, i, array) => {
        if (array.length - 1 === i) {
          return <Fragment key={i}>{message}</Fragment>
        }
        return <Fragment key={i}>{message}<br/></Fragment>
      })}
    </ContentTopMessage>
  }

  return (
    <PIMCard
      headerProps={{title: t('新規登録情報確認.基本情報.見出し')}}
      testId={'block-basic-info'}
    >
      <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>} showEndDivider>
        {topMessage && displayTopMessage()}
        <ConfirmContent
          label={'メールアドレス'} values={[mail]}
          testDataId={'confirm-content-mail'}
        />
        <MemberNameConfirms
          familyName={familyName}
          firstName={firstName}
          familyNameKana={familyNameKana}
          firstNameKana={firstNameKana}
        />
        <ConfirmContent
          label={'性別'} values={[gender ? GENDER[gender] : '']}
          testDataId={'confirm-content-gender'}
        />
        <ConfirmContent
          label={'生年月日'} values={[birthday ?? '']}
          testDataId={'confirm-content-birthday'}
        />
      </PIMStack>
    </PIMCard>
  )
}
